// src/language-utils.ts
var ISO3_TO_ISO1 = {
  // Romance
  fra: "fr",
  fre: "fr",
  spa: "es",
  ita: "it",
  por: "pt",
  cat: "ca",
  ron: "ro",
  rum: "ro",
  // Germanic
  eng: "en",
  deu: "de",
  ger: "de",
  nld: "nl",
  dut: "nl",
  swe: "sv",
  dan: "da",
  nor: "no",
  nob: "no",
  nno: "no",
  isl: "is",
  afr: "af",
  // Slavic
  pol: "pl",
  ces: "cs",
  cze: "cs",
  slk: "sk",
  slo: "sk",
  bul: "bg",
  hrv: "hr",
  slv: "sl",
  srp: "sr",
  rus: "ru",
  ukr: "uk",
  bel: "be",
  mkd: "mk",
  // Finno-Ugric
  fin: "fi",
  hun: "hu",
  est: "et",
  // Baltic
  lav: "lv",
  lit: "lt",
  // Greek
  ell: "el",
  gre: "el",
  // Semitic
  ara: "ar",
  heb: "he",
  mlt: "mt",
  // Indo-Iranian
  hin: "hi",
  urd: "ur",
  fas: "fa",
  per: "fa",
  ben: "bn",
  // East Asian
  zho: "zh",
  chi: "zh",
  jpn: "ja",
  kor: "ko",
  // Southeast Asian
  vie: "vi",
  tha: "th",
  ind: "id",
  msa: "ms",
  may: "ms",
  // Others
  tur: "tr",
  aze: "az",
  kaz: "kk",
  uzb: "uz",
  mon: "mn",
  swa: "sw",
  amh: "am"
};
var EXTENDED_LOCALES = {
  // Chinese variants — differentiated by script
  "zh-hans": "zh-cn",
  "zh-hant": "zh-tw",
  "zh-cn": "zh-cn",
  "zh-tw": "zh-tw",
  "zh-sg": "zh-cn",
  // Singapore uses Simplified
  "zh-hk": "zh-tw",
  // HK uses Traditional
  "zh-mo": "zh-tw",
  // Macao uses Traditional
  // Portuguese variants
  "pt-br": "pt-br",
  "pt-pt": "pt",
  // Serbian (Latin vs Cyrillic)
  "sr-latn": "sr",
  "sr-cyrl": "sr",
  // Swedish
  "sv-se": "sv",
  "swe": "sv"
};
function resolveFromIntlLocale(locale) {
  const lang = locale.language.toLowerCase();
  const region = locale.region?.toLowerCase();
  const script = locale.script?.toLowerCase();
  if (lang === "zh") {
    if (script === "hans" || region === "cn" || region === "sg") return "zh-cn";
    if (script === "hant" || region === "tw" || region === "hk" || region === "mo") return "zh-tw";
    return "zh-cn";
  }
  if (lang === "pt" && region === "br") return "pt-br";
  return lang;
}
function normalizeLanguageCode(code) {
  if (!code || typeof code !== "string") return code;
  const cleaned = code.trim().replace(/_/g, "-").toLowerCase();
  if (cleaned in EXTENDED_LOCALES) return EXTENDED_LOCALES[cleaned];
  if (/^[a-z]{3}$/.test(cleaned)) {
    return ISO3_TO_ISO1[cleaned] ?? cleaned;
  }
  try {
    const locale = new Intl.Locale(cleaned);
    return resolveFromIntlLocale(locale);
  } catch {
    return cleaned.split("-")[0];
  }
}
function isSupportedLanguage(code, supportedLngs) {
  return supportedLngs.includes(normalizeLanguageCode(code));
}
var CANONICAL_TO_BCP47 = {};
function toIntlLocale(canonicalCode) {
  return CANONICAL_TO_BCP47[canonicalCode] ?? canonicalCode;
}
function buildFallbackMap(supportedLngs, ultimateFallback = "en") {
  const supported = new Set(supportedLngs);
  const map = {};
  for (const lng of supportedLngs) {
    if (lng === ultimateFallback) continue;
    const chain = [];
    if (lng.includes("-")) {
      const base = lng.split("-")[0];
      if (supported.has(base) && base !== "zh") {
        chain.push(base);
      }
    }
    chain.push(ultimateFallback);
    map[lng] = chain;
  }
  map["default"] = [ultimateFallback];
  return map;
}
export {
  buildFallbackMap,
  isSupportedLanguage,
  normalizeLanguageCode,
  toIntlLocale
};
